// extracted by mini-css-extract-plugin
export default {"container":"Timer_container__34AKH","timerHeader":"Timer_timerHeader__wg-VS"};